import { useForm } from 'react-hook-form'
import { useState, useEffect, useContext, useRef } from 'react'
import axios from 'axios'
import '../../styles/swicthcss.css'
import Swal from 'sweetalert2'
import { projectContext, loadingContext, urlValue, unfolder, openAlert, useTranslate } from '../../lib'
import SelectCodeModal from '../SelectCodeModal'
import SwitchBtn from '../common/SwitchBtn'
import ButtonYesNo from '../common/ButtonYesNo'
import BoxInfo from '../common/BoxInfo'
import { SelectNesting } from '../common/Inputs/Select'
import { InputNesting, TextareaNesting } from '../common/Inputs/Input'
import { Tooltip } from 'react-tooltip'
import { Alerts } from '../common/Alerts'
import { CustomChat } from '../CustomChat'
import { validatePrompt } from '../../lib/promptValidator';
import ExcelUploadButton from './ExcelUploadButton';

export function SettingsOptionsGenAI({ isModalOpen, closeModal, update }) {
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [users, setUsers] = useState([{}])
  const [loading, setLoading] = useContext(loadingContext)
  const [nlp_config, setNlp_config] = useState(null);
  const [bot_type, setBot_type] = useState(false);
  const [default_Sentiment, setDefault_Sentiment] = useState(false);
  const [nlp_configName, setNlp_configName] = useState("Upload");
  const [language, setLanguage] = useState(selectedProject.metadata.language);
  const [campaings, setCampaings] = useState([])
  const [subCampaings, setSubCampaings] = useState([])
  const [selectedSubCampaignId, setSelectedSubCampaignId] = useState(null);
  const [showClosing, setShowClosing] = useState(false);
  const [questionChange, setQuestionChange] = useState("")
  const campaingRef = useRef()
  const subCampaingRef = useRef()
  const [hold, setHold] = useState(0)
  const [useValueQuestion, setUseValueQuestion] = useState(0)
  const [role, setRole] = useState(0)
  const timeHoldRef = useRef();
  const timeHoldAmountRef = useRef();
  const sentimentBotRef = useRef();
  const useDefaultSentimentRef = useRef();
  const [radomVoice, setRadomVoice] = useState(false)
  const [voices, setVoices] = useState([])
  const [error, setError] = useState({ name: "" })
  const url_simulationRef = useRef();
  const Simulation_Step_number_ref = useRef();
  const affectation_time_ref = useRef();
  const percentage_affectation_ref = useRef();
  const [category, setCategory] = useState('outbound');
  const [transcription, setTranscription] = useState(0);
  const [useDefaultSentiment, setUseDefaultSentiment] = useState(0);
  const [timeHold, setTimeHold] = useState(0);
  const [amountTimeHold, setAmountTimeHold] = useState(0);
  const [modelSentiment, setModelSentiment] = useState('Voice');
  const [alert, setAlert] = useState({ title: '', visible: false })
  const [simulationStatus, setSimulationStatus] = useState(null);
  const [assistedSimulation, setAssistedSimulation] = useState(null);
  const [channel, setChannel] = useState("voice")
  const [questions, setQuestions] = useState([{ question: "", suggested: "", value: "0" }, { question: "", suggested: "", value: "0" }, { question: "", suggested: "", value: "0" }])
  const [customChats, setCustomChats] = useState([]);
  const [selectedChatOption, setSelectedChatOption] = useState(0);
  const [showCustomChatForm, setShowCustomChatForm] = useState(false);
  const [phrasesList, setPhrasesList] = useState('');
  const [contactDriverForm, setContactDriverForm] = useState(false);
  const [translationAssessment, setTranslationAssessment] = useState(selectedProject.otherLenguage === 1);
  const [maxUserResponseTimeValue, setMaxUserResponseTimeValue] = useState(0);
  const [bot_respose_time, setBot_respose_time] = useState(0);
  
  const industry_ref = useRef();
  const problem_ref = useRef();
  const solucion_ref = useRef();
  const campaign_ref = useRef();
  const subcampaing_ref = useRef();
  const modelSentiment_ref = useRef();
  const voice_ref = useRef();
  const welcome_mesageRef = useRef();
  const closing_mesageRef = useRef();
  const minimunCallDurations = useRef();
  const maximunCallDurations = useRef();
  const maxUserResponseTime = useRef();
  const contact_driver_role_ref = useRef();
  const contact_driver_task_ref = useRef();
  const contact_driver_context_ref = useRef();
  const contact_driver_rules_ref = useRef();
  const contact_driver_forbidden_actions_ref = useRef();
  const contact_driver_default_fallback_ref = useRef();
  const contact_driver_example_ref = useRef();
  const contact_driver_other_ref = useRef();
  const bot_respose_time_ref = useRef();
  const model_llm_ref = useRef();
  const temperature_ref = useRef();
  const top_p_ref = useRef();
  const top_k_ref = useRef();
  const phrases_list_ref = useRef();
  const minimum_passing_score_ref = useRef();
  const { t } = useTranslate();
  const logsQuestions = useRef('');
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()
  const roles = {
    1: 'Admin',
    2: 'Manager',
    3: 'Editor',
    4: 'Reader',
  }

  const getUsers = async () => {

    try {
      let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token


      const response = await axios({
        method: 'get',
        url: `${urlValue}/studio/user/users-project/${selectedProject.id}`,
        headers: {
          'access-token': token,
        },
      })

      setUsers(response.data)

      return response;
    } catch (error) {
      console.log(error)

      return error
    }

  }

  useEffect(() => {
    (async () => { await getUsers(); })()

  }, [])

  useEffect(() => {
    if (maxUserResponseTime.current) {
      maxUserResponseTime.current.value = maxUserResponseTimeValue;
    }
    if (bot_respose_time_ref.current) {
        bot_respose_time_ref.current.value = bot_respose_time;
    }

  }, [channel])

  useEffect(() => {
    (async () => {
      setRole(unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').role)
      await fetchVoice();
      await fetchCampaing();
      const subCampaingsData = await fetchSubCampaing();
      await fetchCustomChats();
      const projectData = await getProject();
      
      if (projectData?.data?.sub_campaing_id && subCampaingsData.data.data.length>0) {

        const selectedSubCampaign = subCampaingsData.data.data.find(
          subCampaign => subCampaign.id === parseInt(projectData.data.sub_campaing_id)
        );
        if (selectedSubCampaign) {
          setSelectedSubCampaignId(selectedSubCampaign.id);
          setPhrasesList(convertPhrasesListToString(selectedSubCampaign.phrases_list || ''));
        }
      }

    })()

  }, []);

  useEffect(() => {
    if (subCampaings.length > 0 && selectedSubCampaignId) {
      const selectedSubCampaign = subCampaings.find(
        subCampaign => subCampaign.id === parseInt(selectedSubCampaignId)
      );
      if (selectedSubCampaign) {
        setPhrasesList(convertPhrasesListToString(selectedSubCampaign.phrases_list || ''));
      }
    }
  }, [subCampaings, selectedSubCampaignId]);

  const ChangeModelSentiment = (e) => {
    if (e.target.value === 'Voice') {
      selectedProject.bot_sentiment = 0;
    }
  }

  const containsEmoji = (str) => {
    if (!str) return false;

    try {
      // Usa Unicode property escapes (mejor soporte en navegadores modernos)
      const re = /(\p{Emoji_Presentation}|\p{Extended_Pictographic})/u;
      return re.test(str);
    } catch (e) {
      // Fallback para navegadores antiguos
      const fallback = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
      return fallback.test(str);
    }
  };

  const onChangeStatusSimulation = async () => {
    setSimulationStatus((prev) => prev === 0 ? 1 : 0)
    document.getElementById('url_tp_simulation').value = '';
    document.getElementById('Simulation_Step_number_ref').value = '0';
    setAssistedSimulation(0)


  }

  const saveBotSentimentConfig = function (e) {
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken

    axios({
      method: 'post',
      url: `${urlValue}/studio/project/${selectedProject.id}/bot_sentiment`,
      headers: {
        user: id,
        'access-token': token,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {
        bot_sentiment: e.target.value,
      }
    }).then(function (res) {
      // console.log('res');
    }).catch(error => {
      console.log('Error to try update bot sentiment: ', error);
    })
  }


  const saveProject = (e) => {
    e.preventDefault();
    let ok = true
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let valueTotal = 0
    const name = selectedProject.name;
    const campaignIdTemp = (campaign_ref.current?.value || 0) == 0 ? selectedProject.campaing : campaign_ref.current?.value;
    const subCampaignIdTemp = (subcampaing_ref.current?.value || 0) == 0 ? selectedProject.sub_campaing : subcampaing_ref.current?.value;
    
    const exp = /^[A-Za-z0-9-,._'\s]+$/g;
    if (!exp.test(name)) {
      ok = false;
      openAlert('#alert-ac', () => {setAlert({title: t('errors.nameInvalid'), visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
    }

    if ((campaignIdTemp || 0) == 0 || (subCampaignIdTemp || 0) == 0) {
      ok = false;
      openAlert('#alert-ac', () => {setAlert({title: t('alerts.selectCampaignSubcampaign'), visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
    }

    if (useValueQuestion == 1) {
      for (let i = 0; i < questions.length; i++) {
        if ((parseFloat(questions[i].value) || 0) <= 0) {          
          ok = false;
          openAlert('#alert-ac', () => {setAlert({title: t('alerts.valueQuestions'), visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );  
          break;
        }
        valueTotal = valueTotal + parseFloat(questions[i].value)
      }

      if (valueTotal != 100) {
        ok = false;
        openAlert('#alert-ac', () => {setAlert({title: t('alerts.valueQuestions'), visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
      }
    }

    const invalidQuestions = questions.filter((q) => q.question.includes('"'));
    if (invalidQuestions.length > 0) {
      ok = false;
      openAlert('#alert-ac', () => { setAlert({ title: t('alerts.doubleQuotesQuestions'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
    }

    if ((top_k_ref.current?.value || 0) < 0 || (top_k_ref.current?.value || 0) > 250 ) {
      ok = false;
      openAlert('#alert-ac', () => {setAlert({title: t('alerts.topKValue'), visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
    }

    const minCallTime = Number(minimunCallDurations.current?.value || 0);
    const maxCallTime = Number(maximunCallDurations.current?.value || 0);
    if (minCallTime > maxCallTime) {
      ok = false;
      openAlert(
        '#alert-ac',
        () => setAlert({ title: t('alerts.valideMaxAndMinCall'), visible: true, error: true }),
        4000,
        () => setAlert({ ...alert, visible: false })
      );
    }    
    const emojiRole = containsEmoji(contact_driver_role_ref?.current?.value)
    const emojiTask = containsEmoji(contact_driver_task_ref?.current?.value)
    const emojiContext = containsEmoji(contact_driver_context_ref?.current?.value)
    const emojiRules = containsEmoji(contact_driver_rules_ref?.current?.value)
    const emojiForbidden = containsEmoji(contact_driver_forbidden_actions_ref?.current?.value)
    const emojiDefault = containsEmoji(contact_driver_default_fallback_ref?.current?.value)
    const emojiExample = containsEmoji(contact_driver_example_ref?.current?.value)
    const emojiOther = containsEmoji(contact_driver_other_ref?.current?.value)

    if (emojiRole || emojiTask || emojiContext || emojiRules || emojiForbidden || emojiForbidden || emojiDefault 
      || emojiExample || emojiOther) 
    {
      ok = false;
      openAlert(
        '#alert-ac',
        () => setAlert({ title: t('alerts.validateEmoji'), visible: true, error: true }),
        4000,
        () => setAlert({ ...alert, visible: false })
      );
    }

    if (ok) {

      savePhrasesListSubCampaign();

      //quito el id temporal
      const cleanedQuestions = questions?.map(({ id, ...rest }) => rest);
      const voiceIdTemp = (voice_ref.current?.value || 0) == 0 ? selectedProject.voice_id : voice_ref.current?.value;
      
      const dataSend = {
        id: selectedProject.id,
        name: selectedProject.name,
        //Se cambio a null temporalmente hasta la primera entrega despues agregar id de cada nlp Dlowflow RASA
        nlp: selectedProject.nlp,
        nlp_url: selectedProject.nlp_url,
        metadata: { "description": selectedProject.metadata.description, "language": selectedProject.metadata.language },
        //Se cambio a null temporalmente hasta la primera entrega despues /agregar la imagen
        image: selectedProject.image,
        hold: hold,
        time_hold_amount: timeHoldAmountRef.current?.value || 0,
        time_hold_seconds: timeHoldRef.current?.value || 0,
        use_hold: hold ? 1 : 0,
        channel: channel,
        random_voice: radomVoice ? 1 : 0,
        use_default_sentiment: selectedProject.use_default_sentiment,
        bot_sentiment: selectedProject.bot_sentiment,
        model_sentiment: modelSentiment_ref.current?.value,
        url_tp_simulation: url_simulationRef.current.value,
        simulation_status: simulationStatus,
        category: category,
        outbound_call: category === 'outbound' ? 1 : 0,
        transcription: transcription,
        campaing: campaignIdTemp,
        sub_campaing: subCampaignIdTemp,
        voice: voiceIdTemp,
        type: selectedProject.type,
        contact_driver_role: contact_driver_role_ref?.current?.value,
        contact_driver_task: contact_driver_task_ref?.current?.value,
        contact_driver_context: contact_driver_context_ref?.current?.value,
        contact_driver_rules: contact_driver_rules_ref?.current?.value,
        contact_driver_forbidden_actions: contact_driver_forbidden_actions_ref?.current?.value,
        contact_driver_default_fallback: contact_driver_default_fallback_ref?.current?.value,
        contact_driver_example: contact_driver_example_ref?.current?.value,
        contact_driver_other: contact_driver_other_ref?.current?.value,
        evaluation_questions: cleanedQuestions,
        industry: industry_ref.current?.value,
        welcome_msg: welcome_mesageRef?.current?.value || selectedProject.welcome_msg,
        closing_msg: closing_mesageRef?.current?.value || selectedProject.closing_msg,
        min_call_time: minimunCallDurations.current?.value || 0,
        max_call_time: maximunCallDurations.current?.value || 0,
        max_user_response_time: maxUserResponseTime.current?.value || 0,
        bot_response_time: bot_respose_time_ref.current?.value || 1,
        num_simulation_steps: Simulation_Step_number_ref.current?.value || 1,
        assisted_simulation: assistedSimulation,
        custom_chat: selectedChatOption,
        model_llm: model_llm_ref.current?.value || selectedProject.model_llm,
        temperature: temperature_ref.current?.value || selectedProject.temperature,
        top_p: top_p_ref.current?.value || selectedProject.top_p,
        top_k: top_k_ref.current?.value || selectedProject.top_k,
        minimum_passing_score: minimum_passing_score_ref.current?.value || 70,
        use_value_question: useValueQuestion,
        otherLenguage: translationAssessment ? 1 : 0,
        logsQuestions: logsQuestions.current,
      }
      axios({
        method: 'put',
        url: `${urlValue}/studio/project`,
        headers: {
          user: id,
          'access-token': token,
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true,
        data: dataSend,
      })
        .then(function (response) {
          setSelectedProject({
            ...selectedProject,
            channel: channel,
            voice_id: voice_ref.current?.value || selectedProject?.voice_id,
            campaing: campaign_ref.current?.value,
            sub_campaing: subcampaing_ref.current?.value,
            time_hold_amount: timeHoldAmountRef.current?.value || 0,
            time_hold_seconds: timeHoldRef.current?.value || 0,
            use_hold: hold ? 1 : 0,
            random_voice: radomVoice ? 1 : 0,
            type: selectedProject.type,
            model_sentiment: modelSentiment_ref.current?.value,
            industry: industry_ref.current?.value || 'Other',
            // problem: problem_ref.current?.value,
            // solution: solucion_ref.current?.value,
            contact_driver_role: contact_driver_role_ref?.current?.value,
            contact_driver_task: contact_driver_task_ref?.current?.value,
            contact_driver_context: contact_driver_context_ref?.current?.value,
            contact_driver_rules: contact_driver_rules_ref?.current?.value,
            contact_driver_forbidden_actions: contact_driver_forbidden_actions_ref?.current?.value,
            contact_driver_default_fallback: contact_driver_default_fallback_ref?.current?.value,
            contact_driver_example: contact_driver_example_ref?.current?.value,
            contact_driver_other: contact_driver_other_ref?.current?.value,

            evaluation_questions: questions,
            welcome_msg: welcome_mesageRef?.current?.value || selectedProject.welcome_msg,
            closing_msg: closing_mesageRef?.current?.value || selectedProject.closing_msg,
            url_tp_simulation: url_simulationRef.current.value,
            simulation_status: simulationStatus,
            category: category,
            outbound_call: category === 'outbound' ? 1 : 0,
            min_call_time: minimunCallDurations.current?.value || 0,
            max_call_time: maximunCallDurations.current?.value || 0,
            max_user_response_time: maxUserResponseTime.current?.value || 0,
            bot_response_time: bot_respose_time_ref.current?.value || 1,
            num_simulation_steps: Simulation_Step_number_ref.current?.value || 1,
            assisted_simulation: assistedSimulation,
            custom_chat: selectedChatOption,
            model_llm: model_llm_ref.current?.value || 'Sonnetv2',
            temperature: temperature_ref.current?.value || 0.1,
            top_p: top_p_ref.current?.value || 0.2,
            top_k: top_k_ref.current?.value || 20,
            minimum_passing_score: minimum_passing_score_ref.current?.value || 70,
            use_value_question: useValueQuestion,
            otherLenguage: translationAssessment ? 1 : 0,
          })
          logsQuestions.current = ''
          openAlert('#alert-ac', () => { setAlert({ title: t('alerts.settingsSaved'), visible: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
          getProject();
          setLoading(false)
        })
        .catch(function (error) {
          openAlert('#alert-ac', () => { setAlert({ title: t('alerts.settingsNotSaved'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
          console.error ("error ", error)
        })
    }
  }

  const savePhrasesListSubCampaign = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
  
    // Clean phrases using regex to keep only letters, numbers and spaces
    const cleanPhrase = (phrase) => {
      return phrase.replace(/[^a-zA-Z0-9\s]/g, '').trim();
    };
  
    // Process phrases_list_ref into JSON format
    const phrasesListSend = phrasesList.split(';')
      .map((phrase, index) => ({
        id: index + 1,
        phrase: cleanPhrase(phrase)
      }))
      .filter(item => item.phrase !== ''); 
  
    const dataSend = {
      id: parseInt(subcampaing_ref.current.value),
      phrases_list: phrasesListSend
    };
    
    try {
      const response = await axios({
        method: 'put',
        url: `${urlValue}/studio/project/camp/sub-campaing/phrases-list`,
        headers: {
          user: id,
          'access-token': token,
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true,
        data: dataSend,
      });
  
      if (response.status === 200) {
        console.log('Phrases list updated successfully');
        // Update local state to reflect changes
        const updatedSubCampaings = subCampaings.map(subCamp => {
          if (subCamp.id === parseInt(subcampaing_ref.current.value)) {
            return { ...subCamp, phrases_list: phrasesList };
          }
          return subCamp;
        });
        setSubCampaings(updatedSubCampaings);
      }
    } catch (error) {
      console.error('Error updating phrases list:', error);
      openAlert('#alert-ac', () => {
        setAlert({
          title: t('alerts.errorPhrasesList'),
          visible: true,
          error: true
        });
      }, 4000, () => {
        setAlert({ ...alert, visible: false });
      });
    }
  };

  const getProject = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    setLoading(true)
    try {
      const response = await axios({
        method: 'get',
        url: `${urlValue}/studio/project/${selectedProject.id}`,
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      })

      setSelectedProject(response.data)

      // document.getElementById('url_tp_simulation').value = response.data.url_tp_simulation;
      // document.getElementById('bot_sentiment').value = response.data.bot_sentiment;

      setLanguage(response.data.metadata.language);
      setTimeHold(response.data.TimeSecondHold);
      setAmountTimeHold(response.data.AmountTimeHold);
      setRadomVoice(response.data.random_voice);
      setHold(response.data.useHold);
      setUseDefaultSentiment(response.data.use_default_sentiment)
      setTranscription(response.data.transcription)
      // setCategory(response.data.category)
      setCategory(response.data.outbound_call === 1 ? "outbound" : "inbound")
      setChannel(response.data.channel)      
      
      setUseDefaultSentiment(response.data.use_default_sentiment)
      setTimeHold(response.data.TimeSecondHold)
      setAmountTimeHold(response.data.AmountTimeHold)
      setModelSentiment(response.data.model_sentiment)
      setUseValueQuestion(response.data.use_value_question || selectedProject?.use_value_question)
      const initialQuestions = response.data?.gen_ai.evaluation_questions?.map((q, i) => ({ ...q, id: `${i}-${Date.now()}` }))
      setQuestions(initialQuestions || []);
      setAssistedSimulation(selectedProject.assisted_simulation)
      setSimulationStatus(selectedProject?.simulation_status)
      setTranslationAssessment(response.data.otherLenguage === 1);
      setMaxUserResponseTimeValue(response.data.max_user_response_time || 0);
      setBot_respose_time(response.data.bot_response_time || 0);
      
      if (voice_ref.current && response.data.voice_id) {
        voice_ref.current.value = response.data.voice_id;
      } else {
        console.warn('voice_ref or voice_id is undefined');
      }
      industry_ref.current.value = response.data?.gen_ai.industry || 'Other';
      // problem_ref.current.value = response.data?.gen_ai.problem;
      // solucion_ref.current.value = response.data?.gen_ai.solution;
      if(contact_driver_role_ref.current){
        contact_driver_role_ref.current.value = response.data?.gen_ai.contact_driver_role;
      }
      if(contact_driver_task_ref.current){
        contact_driver_task_ref.current.value = response.data?.gen_ai.contact_driver_task;
      }
      if(contact_driver_context_ref.current){
        contact_driver_context_ref.current.value = response.data?.gen_ai.contact_driver_context;
      }
      if(contact_driver_rules_ref.current){
        contact_driver_rules_ref.current.value = response.data?.gen_ai.contact_driver_rules;
      }
      
      if (contact_driver_forbidden_actions_ref.current) {
          contact_driver_forbidden_actions_ref.current.value = response.data?.gen_ai?.contact_driver_forbidden_actions;
      }
      
      if (contact_driver_default_fallback_ref.current) {
          contact_driver_default_fallback_ref.current.value = response.data?.gen_ai?.contact_driver_default_fallback;
      }
      
      if (contact_driver_example_ref.current) {
          contact_driver_example_ref.current.value = response.data?.gen_ai?.contact_driver_example;
      }
      
      if (contact_driver_other_ref.current) {
          contact_driver_other_ref.current.value = response.data?.gen_ai?.contact_driver_other;
      }
      
      if (campaign_ref.current) {
          campaign_ref.current.value = response.data.campaing_id;
      }
      
      if (subcampaing_ref.current) {
          subcampaing_ref.current.value = response.data.sub_campaing_id;
      }
      
      if (modelSentiment_ref.current) {
          modelSentiment_ref.current.value = response.data.model_sentiment;
      }
      
      if (timeHoldRef.current) {
          timeHoldRef.current.value = response.data.TimeSecondHold;
      }
      
      if (timeHoldAmountRef.current) {
          timeHoldAmountRef.current.value = response.data.AmountTimeHold;
      }
      
      if (url_simulationRef.current) {
          url_simulationRef.current.value = response.data.url_tp_simulation;
      }
      
      if (Simulation_Step_number_ref?.current) {
          Simulation_Step_number_ref.current.value = response.data.num_simulation_steps;
      }
      
      if (welcome_mesageRef.current) {
          welcome_mesageRef.current.value = response.data.welcome_msg;
      }

      if (minimunCallDurations.current) {
          minimunCallDurations.current.value = response.data.min_call_time || 0;
      }

      if (maximunCallDurations.current) {
        maximunCallDurations.current.value = response.data.max_call_time || 0;

        if ((response.data?.max_call_time || 0) !== 0) {
          setShowClosing(true)
        }
      }

      if (closing_mesageRef.current) {
        closing_mesageRef.current.value = response.data.closing_msg;
      }
      
      if (model_llm_ref.current) {
          model_llm_ref.current.value = response.data.model_llm || 'claude';
      }
      
      if (temperature_ref.current) {
          temperature_ref.current.value = response.data.temperature || 0;
      }
      
      if (top_p_ref.current) {
          top_p_ref.current.value = response.data.top_p || 0;
      }
      
      if (top_k_ref.current) {
          top_k_ref.current.value = response.data.top_k || 0;
      }
      
      if (minimum_passing_score_ref.current) {
          minimum_passing_score_ref.current.value = response.data.minimum_passing_score || 70;
      }

      setLoading(false)
      return response
    }
    catch (error) {
      console.log("Error GetProject", error)
      setLoading(false)
      return error;
    }

  }

  const convertPhrasesListToString = (phrasesListJson) => {
    try {
      if (!phrasesListJson) {
        return '';
      }
      
      let phrasesList 
      if (typeof phrasesListJson === 'string') {
        try {
          phrasesList = JSON.parse(phrasesListJson)
        }
        catch(e){
          console.log("No es un JSON String")
          return phrasesListJson;
        }
      }
      else {
        phrasesList = phrasesListJson;
      }
  
      return Array.isArray(phrasesList) 
        ? phrasesList.map(item => item.phrase).join(';')
        : '';
    } catch (error) {
      console.error('Error converting phrases list:', error);
      return ''; 
    }
  };
  
  const fetchVoice = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    const project_id = selectedProject.id;

    try {
      const url = `${urlValue}/studio/project/voices/all`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          language: language.substring(0, 2) || 'EN',
          'access-token': token,
          'Content-Type': 'application/json',
          'project_id': project_id
        },
      });

      if (rest.status === 200 && rest.data) {
        setVoices(rest.data.data)
        //setTimeout(()=>{document.querySelector("#voice").value = selectedProject.voice_id },700);
      }
      return rest;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  const fetchCampaing = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/project/camp/campaing`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setCampaings(rest.data.data)
      }
      return rest;;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  const fetchSubCampaing = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/project/camp/sub-campaing`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setSubCampaings(rest.data.data)
      }
      return rest;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  const fetchCustomChats = async () => {
    const predefined = [
      { id: 0, name: 'Standard' },
      { id: 1, name: 'WhatsApp' },
      { id: 2, name: 'Telegram' },
    ];

    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
    const project_id = selectedProject.id;

    try {
      const url = `${urlValue}/studio/project/customchats/all`;

      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
          'project_id': project_id
        },
      });

      if (rest.status === 200 && rest.data.data) {
        setCustomChats([...predefined, ...rest.data.data])
      }
      return rest.data.data;
    } catch (error) {
      setCustomChats(predefined)
      console.log(error)
      return error;
    }
  };

  const industries = [
    { id: 1, name: "BFSI" },
    { id: 2, name: "Gaming" },
    { id: 3, name: "News & Media" },
    { id: 4, name: "Tech App Food & Delivery" },
    { id: 5, name: "Tech-Home Services" },
    { id: 6, name: "Telecom" },
    { id: 7, name: "Travel & Hospitality" },
    { id: 8, name: "Other" },
  ]

  const onChangeQuestion = (e, index) => {
    if (e.target.value.includes('"')) {
      openAlert('#alert-ac', () => { setAlert({ title: t('alerts.doubleQuotesQuestion'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
    }
    const q = [...questions];
    q[index].question = e.target.value
    setQuestions(q)
  }

  const onChangeSuggested = (e, index) => {
    const q = [...questions];
    q[index].suggested = e.target.value
    setQuestions(q)
  }

  const onFocusQuestion = (e, index) => {
    console.log("Foco en la pregunta")
    setQuestionChange(e.target.value)
  }

  const onBlurQuestion = (e, index) => {
    if(questionChange != e.target.value) {
      if (questionChange === '') {
        logsQuestions.current += `Add Question -> ${e.target.value}\n`;
      } else {
        logsQuestions.current += `Modify Question Before -> ${questionChange} After -> ${e.target.value}\n`;
      }      
    }
  }

  const onChangeValue = (e, index) => {
    const q = [...questions];
    q[index].value = e.target.value
    setQuestions(q)
  }

  const addQuestiong = () => {
    setQuestions((prev) => [...prev, { id: `${100}-${Date.now()}`, question: "", suggested: "", value: "0" }])
  }

  const deleteQuestiong = (id) => {
    const q = [...questions];
    const question = q.filter((x) => x.id === id)
    logsQuestions.current += `Delete Question -> ${question[0].question}\n`;
    setQuestions((prev) => prev.filter((x) => x.id !== id));
  }

  const addPromptDefault = () => {

    const DEFAULT_PROMPT = process.env.REACT_APP_PROMPT_START;

    if (contact_driver_context_ref.current) {
      contact_driver_context_ref.current.value = DEFAULT_PROMPT;
    }

  }

  const addPromptDefaultFromServer = async () => {

    if (contact_driver_role_ref.current.value !== '' || contact_driver_task_ref.current.value !== ''
      || contact_driver_context_ref.current.value !== '' || contact_driver_rules_ref.current.value !== ''
      || contact_driver_forbidden_actions_ref !== '' || contact_driver_default_fallback_ref.current.value !== ''
      || contact_driver_example_ref.current.value !== '' || contact_driver_other_ref.current.value !== ''
    ) {
      const result = await Swal.fire({
        title: t('menu.confirmation'),
        text: t('alerts.updatePrompt'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: t('common.yes'),
        cancelButtonText: t('common.no')
      });

      if (!result.isConfirmed) {
        return;
      }
    }

    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

    axios({
      method: 'get',
      url: `${urlValue}/studio/prompt/library/default`,
      headers: {
        user: id,
        'access-token': token,
      },
    })
      .then(function (response) {
        contact_driver_role_ref.current.value = response?.data?.role;
        contact_driver_task_ref.current.value = response?.data?.task;
        contact_driver_context_ref.current.value = response?.data?.context;
        contact_driver_rules_ref.current.value = response.data?.rules;
        contact_driver_forbidden_actions_ref.current.value = response.data?.forbidden_actions;
        contact_driver_default_fallback_ref.current.value = response.data?.default_fallback;
        contact_driver_example_ref.current.value = response.data?.example;
        contact_driver_other_ref.current.value = response.data?.other;
      })
      .catch(function (error) {
        openAlert('#alert-ac', () => { setAlert({ title: t('alerts.failedTemplate'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
        console.error(error)
        // onClose()
        setLoading(false)
      });
  }

  const showContactDriverForm = async (show)=>{
    setContactDriverForm(show);
    //await getProject();
  }

  const verifyPrompt = () => {
    const refs = {
      contact_driver_role_ref,
      contact_driver_task_ref,
      contact_driver_context_ref,
      contact_driver_rules_ref,
      contact_driver_forbidden_actions_ref,
      contact_driver_default_fallback_ref,
      contact_driver_example_ref
    };

    return validatePrompt(refs, t);
  };

  const changeMaxCallDuration = (e) => {
    if (e.target.value == 0){
      setShowClosing(false)
    } else {
      setShowClosing(true)
    }
    
  }

  return (
    <>
      <form onSubmit={saveProject} className="settings-container"
        style={{ backgroundColor: '#F9F9F9', paddingRight: 17, borderRadius: 25, height: '90%', minHeight: 600, paddingBottom: 72 }}>
        <div className="scroll-internal ">
          {/* <h2 className="pl-3" style={{ color: '#0B5FA3', fontSize: 18 }}>General Project Settings</h2> */}
          
          <div className="pl-3 d-flex flex-row" style={{ justifyContent: 'space-between' }}>
            <div className="d-flex flex-column pl-2" style={{ width: '100%', paddingRight: 15 }}>
              <div className='mt-4 d-flex flex-row align-items-center justify-content-between w-100'>
              <div className='d-flex flex-row align-items-center'>
                <h2 className="m-0" style={{ color: '#0B5FA3', fontSize: 18, minWidth: 130 }}>
                  {t('menu.genai.contactDriver')}
                </h2>
                
                <button id='arrow-down-btn' style={{display: !contactDriverForm ? 'block' : 'none'}} 
                  className='ml-3' type='button' onClick={()=>showContactDriverForm(true)}>
                  <img src='/icons/arrow_down.png' style={{ width: 20 }} alt='' />
                </button>

                <button id='arrow-down-btn' style={{display: contactDriverForm ? 'block' : 'none'}} 
                  className='ml-3' type='button' onClick={()=>showContactDriverForm(false)}>
                  <img src='/icons/arrow_up.png' style={{ width: 20 }} alt='' />
                </button>
              </div>
              
              <div className="flex-row align-items-center" 
                style={{ marginRight: 20, display: contactDriverForm ? 'flex' : 'none', justifyContent: 'space-between', minWidth: 316 }}>
                <button className='btn-add' type='button' onClick={verifyPrompt}>
                  <img src='/icons/verify_prompt.png' style={{ width: 22 }} alt='' />
                  <span className='ml-5'>{t('menu.genai.verifyPrompt')}</span>
                </button>
                <button className='btn-add ml-5' type='button' onClick={addPromptDefaultFromServer}>
                  <img src='/icons/add-icon-nt.png' style={{ width: 22 }} alt='' />
                  <span className='ml-5'>{t('menu.genai.addPromptTemplate')}</span>
                </button>
              </div>

            </div>
              <div style={{display: contactDriverForm ? 'flex' : 'none'}}
                className="flex-row flex-wrap">
                <div className='d-flex flex-column' style={{ flexGrow: '1' }}>
                  <div className='mt-4 d-flex flex-row align-items-center justify-content-between'>
                    <label htmlFor="contact_driver_role" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>{t('menu.genai.role')}:</label>
                  </div>
                  <div className='flex items-center'>
                    <TextareaNesting
                      row={4}
                      ref={contact_driver_role_ref} id="contact_driver_role"
                      title="" containerClass="flex-1 mr-2 mt-0"
                    />
                  </div>

                  <div className='mt-4 d-flex flex-row align-items-center justify-content-between'>
                    <label htmlFor="contact_driver_task" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>{t('menu.genai.task')}:</label>
                  </div>
                  <div className='flex items-center'>
                    <TextareaNesting
                      row={4}
                      ref={contact_driver_task_ref} id="contact_driver_task"
                      title="" containerClass="flex-1 mr-2 mt-0 "
                    />

                  </div>
                </div>

                <div className='d-flex flex-column mt-2' style={{ flexGrow: '2' }}>
                  <div className='d-flex flex-row align-items-center justify-content-between'>
                    <label htmlFor="contact_driver_context" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>{t('menu.genai.context')}:</label>
                  </div>
                  <div className='flex items-center'>
                    <TextareaNesting
                      row={11}
                      ref={contact_driver_context_ref} id="contact_driver_context"
                      title="" containerClass="flex-1 mr-2 mt-0 "
                    />
                  </div>
                </div>
                <div className='d-flex flex-column w-100' style={{ flexGrow: '1' }}>
                  <div className='mt-4 d-flex flex-row align-items-center justify-content-between'>
                    <label htmlFor="contact_driver_rules" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>{t('menu.genai.rules')}:</label>
                  </div>
                  <div className='flex items-center'>
                    <TextareaNesting
                      row={4}
                      ref={contact_driver_rules_ref} id="contact_driver_rules"
                      title="" containerClass="flex-1 mr-2 mt-0"
                    />
                  </div>
                </div>  

                <div className='d-flex flex-column w-100' style={{ flexGrow: '1' }}>
                  <div className='mt-4 d-flex flex-row align-items-center justify-content-between'>
                    <label htmlFor="contact_driver_forbidden_actions" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>{t('menu.genai.forbiddenActions')}:</label>
                  </div>
                  <div className='flex items-center'>
                    <TextareaNesting
                      row={4}
                      ref={contact_driver_forbidden_actions_ref} id="contact_driver_forbidden_actions"
                      title="" containerClass="flex-1 mr-2 mt-0"
                    />
                  </div>
                </div>

                <div className='d-flex flex-column w-100' style={{ flexGrow: '1' }}>
                  <div className='mt-4 d-flex flex-row align-items-center justify-content-between'>
                    <label htmlFor="contact_driver_default_fallback" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>{t('menu.genai.defaultFallback')}:</label>
                  </div>
                  <div className='flex items-center'>
                    <TextareaNesting
                      row={4}
                      ref={contact_driver_default_fallback_ref} id="contact_driver_default_fallback"
                      title="" containerClass="flex-1 mr-2 mt-0"
                    />
                  </div>
                </div>

                <div className='d-flex flex-column w-100' style={{ flexGrow: '1' }}>
                  <div className='mt-4 d-flex flex-row align-items-center justify-content-between'>
                    <label htmlFor="contact_driver_example" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>{t('menu.genai.example')}:</label>
                  </div>
                  <div className='flex items-center'>
                    <TextareaNesting
                      row={4}
                      ref={contact_driver_example_ref} id="contact_driver_example"
                      title="" containerClass="flex-1 mr-2 mt-0"
                    />
                  </div>
                </div>

                <div className='d-flex flex-column w-100' style={{ flexGrow: '1' }}>
                  <div className='mt-4 d-flex flex-row align-items-center justify-content-between'>
                    <label htmlFor="contact_driver_other" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>Other:</label>
                  </div>
                  <div className='flex items-center'>
                    <TextareaNesting
                      row={4}
                      ref={contact_driver_other_ref} id="contact_driver_other"
                      title="" containerClass="flex-1 mr-2 mt-0"
                    />
                  </div>
                </div>

              </div>


              <div className='separator-n mt-4 mb-3' />

              <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                <h1 className='mt-2 mb-1' style={{ marginBottom: 2, marginTop: 15 }}>{t('menu.genai.evaluationFormulary')}</h1>
                <div className='ml-2'>
                    <ExcelUploadButton 
                      onQuestionsLoaded={(loadedQuestions) => {
                        setQuestions(loadedQuestions);
                      }}
                      useValueQuestion={useValueQuestion}
                    />
                </div>
              </div>

              <div className='flex  flex-col pb-4 mt-3'>
                <div className='flex flex-column' style={{minWidth: 175, marginBottom: 15}}>
                  <BoxInfo
                    id="questionValue" titleClass='mr-0-4' styles={{ marginBottom: 10 }}
                    title={t('menu.genai.questionValue')}
                    place="top" containerClass='mr-0-5 '
                    content={t('menu.genai.questionValueTooltip')}
                  />
                  <ButtonYesNo
                    onClick={() => setUseValueQuestion((prev) => !prev)}
                    width={140}
                    state={useValueQuestion}
                    height={30}
                  />
                </div>
                {questions?.map((item, index) => (
                  <div style={{borderBottom: '1px solid #A1A1A0', paddingBottom: 30, marginTop: index !== 0 ? 30 : 0}}>
                    <div key={item.id} className='flex items-end flex-1'>
                      <InputNesting
                        containerClass="w-full"
                        defaultValue={item.question}
                        onChange={(e) => onChangeQuestion(e, index)}
                        title={`${t('common.question')} ${index + 1}:`}
                        onFocus={(e) => onFocusQuestion(e, index)}
                        onBlur={(e) => onBlurQuestion(e, index)}
                      />
                      <button type='button' className='ml-2 btn-delete  ' style={{ marginBottom: 3 }} onClick={() => deleteQuestiong(item.id)} >
                        <img src={'/icons/trash-1.png'} alt='' style={{ width: 22 }} />
                      </button>
                    </div>
                    <div key={`valuequestion ${item.id}:`} className='flex items-end flex-1 mt-2'>
                      <InputNesting
                        containerClass="w-full"
                        defaultValue={item?.suggested}
                        onChange={(e) => onChangeSuggested(e, index)}
                        title={`${t('menu.feedback')} ${index + 1}:`}
                      />
                      <InputNesting
                        containerClass="mr-0-5"
                        defaultValue={item?.value}
                        onChange={(e) => onChangeValue(e, index)}
                        title={`${t('common.value')} ${index + 1}:`}
                        disabled={!useValueQuestion}
                        contentStyle={{ width: '100px', marginLeft: '5px' }}
                      />
                    </div>
                  </div>
                ))}
                <button className='btn-add mt-2' type='button' onClick={addQuestiong}>
                  <img src='/icons/add-icon-nt.png' style={{ width: 22, minWidth: 25 }} alt='' />
                  <span className='ml-5'>{t('menu.genai.addQuestion')}</span>
                </button>
              </div>

              <div style={{width: '100%', borderTop: '1px solid #c9c9c9'}} />

              <div className='d-flex flex-row flex-wrap pb-4 mt-2'>
                <div className="inputs" style={{ marginTop: 25 }}>
                  <div className="input flex flex-row items-center">
                    <BoxInfo
                      id="bottype-tp" titleClass='mr-0-4'
                      title={`${t('menu.genai.botType')}:`} styles={{ whiteSpace: 'nowrap' }}
                      place="top" containerClass='mr-0-5'
                      content={t('menu.genai.botTypeTooltip')}
                    />
                    <div className="ml-2 list_bot_type d-flex flex-row align-items-center" >
                      <ButtonYesNo
                        onClick={() => setChannel((prev) => prev === "voice" ? "chat" : "voice")}
                        width={170}
                        state={channel === "chat" ? false : true}
                        height={30}
                        Yes={t('menu.voiceBot')}
                        No={t('menu.chatBot')}
                      />
                    </div>
                  </div>
                </div>
                <div className="inputs" style={{ marginTop: 25, marginLeft: 40 }}>
                  <div className="input d-flex flex-row align-items-center">
                    <span style={{minWidth: 112}}>{t('menu.genai.interactionType')}:</span>
                    <div className="list_call_type ml-2 d-flex flex-row align-items-center">
                      <ButtonYesNo
                        onClick={() => setCategory((prev) => prev === "outbound" ? "inbound" : "outbound")}
                        width={170}
                        state={category === "outbound" ? false : true}
                        height={30}
                        Yes={t('common.inbound')}
                        No={t('common.outbound')}
                      />
                    </div>
                  </div>
                </div>

                <div className="inputs" style={{ marginTop: 25 }}>
                  <div className="input d-flex flex-row align-items-center">
                    <span style={{minWidth: 140}}>{t('menu.genai.transcriptionEnable')}:</span>
                    <div className="list_call_type ml-2 d-flex flex-row align-items-center">
                      <ButtonYesNo
                        onClick={() => setTranscription((prev) => prev == 0 ? 1 : 0)}
                        width={180}
                        state={transcription}
                        height={30}
                        Yes={t('common.true')}
                        No={t('common.false')}
                        />
                    </div>
                    <span style={{whiteSpace: 'nowrap'}} className='ml-5'>{t('menu.genai.translationAssesment')}:</span>
                    <div className="list_call_type d-flex flex-row align-items-center" style={{marginLeft: 5}}>
                      <ButtonYesNo
                        onClick={() => setTranslationAssessment(prev => !prev)}
                        width={170}
                        state={translationAssessment}
                        height={30}
                        Yes={t('menu.enabled')}
                        No={t('menu.disabled')}
                      />
                    </div>
                  </div>
                </div>

                <div className='d-flex flex-row w-100 mt-3 pb-4'>
                  <div className='d-flex flex-column' style={{ flexGrow: '1' }}>
                    <SelectNesting
                      ref={campaign_ref} id="campaing"
                      title={`${t('common.campaign')}:`} containerClass=" mr-2"
                    >  {campaings.map((item, index) => (<option key={`campaign ${index + 1}:`} value={item.id}>{item.name}</option>))}
                    </SelectNesting>

                    <SelectNesting
                      ref={subcampaing_ref} id="subcampaing"
                      title={`${t('common.subCampaign')}:`} containerClass=" mr-2 mt-5"
                      onChange={(e) => {
                        setSelectedSubCampaignId(e.target.value);
                      }}
                    >  {subCampaings.map((item, index) => (<option key={`subcampaign ${index + 1}:`} value={item.id}>{item.name}</option>))}
                    </SelectNesting>

                    <SelectNesting
                      ref={industry_ref} id="industry"
                      title={`${t('common.industry')}:`} containerClass=" mr-2 mt-5" defaultValue={industries.find(item => item.id === 8)?.name}
                    >  {industries.map((item, index) => (<option key={index} value={item.name}>{item.name}</option>))}
                    </SelectNesting>                    
                  </div>
                  { category === 'outbound' &&
                    <TextareaNesting
                      containerClass="mr-2  ml-2" style={{ flexGrow: '2', minWidth: 500 }}
                      ref={welcome_mesageRef}
                      id="welcome_mesage"
                      type="text"
                      row={2.5}
                      title={t('menu.genai.outboundCallMessage')}
                    />
                  }

                </div>

                <div style={{width: '100%', borderTop: '1px solid #c9c9c9'}} />

                {channel === 'voice' &&
                  <div className='d-flex flex-row items-center w-100 pb-2 mt-2'>
                    <BoxInfo
                      id="phraseslist"
                      titleClass='w-100'
                      title={t('menu.genai.phrasesList')}
                      place="top"
                      containerClass='mr-0-5'
                      content={t('menu.genai.phrasesListTooltip')}
                    />
                  
                    <div className="flex flex-col items-center">
                      <div className="flex flex-row items-center">
                        <input
                          type="text" style={{width: '20%', minWidth: 300, fontSize: 14}}
                          className="flex-1 input-data mt-5"
                          placeholder={t('menu.genai.typePhraseEnter')}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' && e.target.value.trim()) {
                              e.preventDefault();
                              const currentPhrases = phrases_list_ref.current.value
                                ? phrases_list_ref.current.value.split(';').filter(p => p.trim())
                                : [];
                              const newPhrase = e.target.value.trim();
                              
                              if (!currentPhrases.includes(newPhrase)) {
                                const updatedPhrases = [...currentPhrases, newPhrase];
                                phrases_list_ref.current.value = updatedPhrases.join(';');
                                //console.log("ref current", phrases_list_ref.current.value)
                                setPhrasesList(updatedPhrases.join(';'));

                              }
                              e.target.value = '';
                            }
                          }}
                        />
                      </div>
                      
                      <div className="flex flex-row flex-wrap gap-3 mb-4">
                        {phrasesList.split(';')
                          .filter(phrase => phrase.trim())
                          .map((phrase, index) => (
                            <div
                              key={`phraselist ${index + 1}:`}
                              className="flex items-center gap-2 px-4 py-2 rounded-full shadow-sm"
                              style={{
                                borderWidth: '2px', 
                                padding: '5px',
                                margin: '5px',
                                borderColor: '#0087ff',
                                borderRadius: '50px'
                              }}
                            >
                              <span className="text-gray-700">{phrase}</span>
                              <button
                                type="button"
                                onClick={() => {
                                  const currentPhrases = phrasesList.split(';').filter(p => p.trim());
                                  const updatedPhrases = currentPhrases.filter((_, i) => i !== index);
                                  //phrases_list_ref.current.value = updatedPhrases.join(';');
                                  setPhrasesList(updatedPhrases.join(';'));
                                }}
                                className="p-1 hover:text-red-500 transition-colors duration-200"
                                style={{ marginLeft: '2px' }}
                              >
                                <img 
                                  src="/icons/trash-1.png" 
                                  alt="delete" 
                                  style={{ width: 16, height: 16 }} 
                                />
                              </button>
                            </div>
                          ))}
                      </div>

                      <input
                        type="hidden"
                        ref={phrases_list_ref}
                        defaultValue={phrasesList}
                      />
                    </div>
                  </div>                  
                }

                <div style={{width: '100%', borderTop: '1px solid #c9c9c9'}} />

                <div className='d-flex flex-row flex-wrap w-100 mt-3 pb-4'>

                  {channel === 'voice' &&
                    <div className="d-flex flex-row">
                      <div className="input">
                        <div className='flex flex-column' style={{minWidth: 175}}>
                          <BoxInfo
                            id="ramvoice-tp" titleClass='mr-0-4' styles={{ marginBottom: 10, whiteSpace: 'nowrap' }}
                            title={t('menu.genai.onHoldAvailability')}
                            place="top" containerClass='mr-0-5 '
                            content={t('menu.genai.onHoldAvailabilityTooltip')}
                          />
                          <ButtonYesNo
                            onClick={() => setHold((prev) => !prev)}
                            width={140}
                            state={hold}
                            height={30}
                          />
                        </div>
                      </div>

                      <div className="flex flex-row items-center ml-1">
                        <InputNesting
                          containerClass="mr-3"
                          ref={timeHoldAmountRef} id="timeholdamount"
                          type="number"
                          disabled={!hold} style={{ maxWidth: 100 }}
                          title={t('menu.genai.holdAttempts')}
                        />
                        
                        <InputNesting
                          ref={timeHoldRef} id="timehold"
                          type="number"
                          disabled={!hold}
                          containerClass="mr-3 ml-4" style={{ maxWidth: 100 }}
                          title={t('menu.genai.holdTime')}
                        />
                      </div>
                      <InputNesting
                        ref={minimunCallDurations} id="minimunCallDurations"
                        type="number" style={{maxWidth: 100}}
                        containerClass="mr-2 ml-5 pb-0"
                        title={t('menu.genai.minimunCallDurations')}
                      />
                      <InputNesting
                        ref={maximunCallDurations} id="maximunCallDurations"
                        type="number" style={{maxWidth: 100}}
                        containerClass="mr-2 ml-1 pb-0"
                        title={t('menu.genai.maximunCallDurationsVoice')}
                        onChange={changeMaxCallDuration}
                      />
                    </div>

                  }
                </div>

                { showClosing &&
                  <div className="d-flex flex-row">
                    <TextareaNesting
                      containerClass="mr-2 mb-2" style={{ flexGrow: '1', minWidth: 500 }}
                      ref={closing_mesageRef}
                      id="welcome_mesage"
                      type="text"
                      row={2.5}
                      title= 'Closing Call Message'
                      // {t('menu.genai.outboundCallMessage')}
                    />
                  </div>
                }

                <div style={{width: '100%', borderTop: '1px solid #c9c9c9'}} />

                <div className='mt-3 d-flex flex-row flex-wrap align-items-center w-100 pb-4'>
                  <SelectNesting
                    ref={sentimentBotRef} id="bot_sentiment" onChange={saveBotSentimentConfig}
                    boxInfo={true} tooltipText={t('menu.genai.botSentimentTooltip')}
                    title={t('menu.genai.botSentiment')} containerClass="" style={{ minWidth: 150 }}
                  >
                    <option value="1" selected={selectedProject.bot_sentiment !== 0 ? 'selected' : ''}>{t('common.on')}</option>
                    <option value="0" selected={selectedProject.bot_sentiment === 0 ? 'selected' : ''}>{t('common.off')}</option>
                  </SelectNesting>
                  <SelectNesting
                    ref={modelSentiment_ref} id="model_sentiment"
                    boxInfo={true} tooltipText={t('menu.genai.botSentimentTooltip')}
                    title={t('menu.genai.modelSentiment')} containerClass=" mr-2 ml-3" style={{ minWidth: 150 }}
                  >
                    <option key={`model0`} value={'Phrase'}>{t('common.phrase')}</option>
                    <option key={`model1`} value={'Voice'}>{t('common.voice')}</option>
                    <option key={`model2`} value={'Both'}>{t('common.bothPhraseVoice')}</option>
                  </SelectNesting>  
                </div>

                <div style={{width: '100%', borderTop: '1px solid #c9c9c9'}} />

                {channel === 'voice' &&
                <div className='mt-4 d-flex flex-row flex-wrap align-items-center w-100 pb-4'>
                  
                    <div className="inputs">
                      <div className="input">
                        <div className='d-flex flex-col  w-100 mr-3' style={{ alignItems: "center", flexDirection: "row" }}>
                          <BoxInfo
                            id="ramvoice-tp"
                            titleClass='mr-0-4'
                            title={`${t('menu.genai.randomVoices')}:`}
                            place="top"
                            containerClass='mr-0-5 '
                            content={t('menu.genai.randomVoicesTooltip')}
                          />
                          <ButtonYesNo
                            onClick={() => setRadomVoice((prev) => !prev)}
                            width={150}
                            state={radomVoice}
                            height={30}
                          />
                        </div>
                      </div>
                    </div>
                  
                    <SelectNesting
                      ref={voice_ref} id="voice"
                      boxInfo={true} tooltipText={t('menu.genai.selectVoiceTooltip')}
                      title={`${t('menu.genai.selectVoice')}:`} containerClass="ml-4" style={{ minWidth: 150 }}
                    >  {voices.map((item, index) => (<option key={`voice ${index + 1}:`} value={item.id}>{item.voice}</option>))}
                    </SelectNesting>
                </div>
                }

                <div style={{width: '100%', borderTop: '1px solid #c9c9c9'}} />

                {role == 6 &&
                <div className='mt-4 pb-4 d-flex flex-row flex-wrap align-items-center w-100'>
                  <SelectNesting
                    id="model_genAI"
                    ref={model_llm_ref}
                    containerClass="mr-2"
                    boxInfo={true} tooltipText={t('menu.genai.selectLLMTooltip')}
                    title={t('menu.genai.selectLLM')}
                  >
                    <option key='modelllm0' value='claude'>Claude</option>
                    <option key='modelllm1' value='Open AI'>Open AI</option>
                    <option key='modelllm2' value="tpgenai">TP Gen AI</option>
                    <option key='modelllm3' value="Sonnetv2">Sonnet 3.5V2</option>
                    <option key='modelllm4' value="scout">Llama Scout</option>
                    <option key='modelllm5' value="maverick">Llama Maverick</option>
                    <option key='modelllm6' value="Haiku">Haiku</option>
                    <option key='modelllm6' value="opus4.1">Opus</option>
                  </SelectNesting>
          
                  <SelectNesting
                    id="temperature"
                    ref={temperature_ref}
                    containerClass="mr-2" style={{minWidth: 60}}
                    boxInfo={true} tooltipText= {t('menu.genai.temperatureModelTooltip')}
                    title={t('menu.genai.temperatureModel')}
                  >
                    <option key='temperature0' value='0'>0</option>
                    <option key='temperature1' value='0.1'>0.1</option>
                    <option key='temperature2' value="0.2">0.2</option>
                    <option key='temperature3' value="0.3">0.3</option>
                    <option key='temperature4' value="0.4">0.4</option>
                    <option key='temperature5' value='0.5'>0.5</option>
                    <option key='temperature6' value='0.6'>0.6</option>
                    <option key='temperature7' value="0.7">0.7</option>
                    <option key='temperature8' value="0.8">0.8</option>
                    <option key='temperature9' value="0.9">0.9</option>
                    <option key='temperature10' value="1">1</option>
                  </SelectNesting>
                  
                  <SelectNesting
                    id="top_p"
                    ref={top_p_ref}
                    containerClass="mr-2" style={{minWidth: 60}}
                    boxInfo={true} tooltipText= {t('menu.genai.topPTooltip')}
                    title={`${t('menu.genai.topP')}:`}
                  >
                    <option key='topp0' value='0'>0</option>
                    <option key='topp1' value='0.1'>0.1</option>
                    <option key='topp2' value="0.2">0.2</option>
                    <option key='topp3' value="0.3">0.3</option>
                    <option key='topp4' value="0.4">0.4</option>
                    <option key='topp5' value='0.5'>0.5</option>
                    <option key='topp6' value='0.6'>0.6</option>
                    <option key='topp7' value="0.7">0.7</option>
                    <option key='topp8' value="0.8">0.8</option>
                    <option key='topp9' value="0.9">0.9</option>
                    <option key='topp10' value="1">1</option>
                  </SelectNesting>
                  
                  <InputNesting
                    ref={top_k_ref} id="top_k"
                    type="number"
                    containerClass="mr-2 d-flex flex-row align-center"
                    title={`${t('menu.genai.topK')}:`}
                    boxInfo={true}
                    tooltip={true}
                    tooltipText= {t('menu.genai.topKTooltip')}
                    style={{ maxWidth: 100 }}
                  />

                </div>
                }

                <div style={{width: '100%', borderTop: '1px solid #c9c9c9'}} />

                {channel === 'chat' &&
                <div className='mt-4 pb-4 d-flex flex-row flex-wrap align-items-center w-100'>

                  <InputNesting
                    containerClass="mr-2"
                    ref={maxUserResponseTime} id="maxUserResponseTime"
                    type="number"
                    title={t('menu.genai.maxUserResponseTime')}
                    style={{ maxWidth: 100 }}
                    onChange={(e) => {setMaxUserResponseTimeValue(e.target.value)}}
                  />

                  <InputNesting
                    ref={bot_respose_time_ref} id="bot_respose_time"
                    type="number"
                    containerClass="mr-2"
                    title={t('menu.genai.replyTime')}
                    style={{ maxWidth: 100 }}
                    onChange={(e) => {setBot_respose_time(e.target.value)}}
                  />
                </div>
                }

                {channel === 'chat' &&
                // <div className='mt-4 pb-4 d-flex flex-row flex-wrap align-items-center w-100'>
                <div className={`${channel === 'voice' ? 'hidden' : ''} input`} style={{minWidth: 278, marginBottom: "5px"}}>

                  <SelectNesting
                    id="custom_chat"
                    boxInfo={true} tooltipText={t('menu.genai.customChatTooltip')}
                    title={`${t('menu.genai.customChat')}:`} containerClass="mr-2"
                    onChange={(e) => {
                      const value = e.target.value;
                      //console.log(value);
                      setSelectedChatOption(value === 'new' || value === '' ? '' : value);
                      setShowCustomChatForm(value === 'new');
                    }}
                  >
                    <option value="new">{t('common.new')}</option>
                    {customChats.map((item, index) => (
                      <option key={`customchat ${index + 1}`} value={item.id}>{item.name}</option>
                    ))}
                  </SelectNesting>

                  {showCustomChatForm && (
                    <CustomChat
                      update={() => { fetchCustomChats() }}
                    />
                  )}
                {/* </div> */}
                </div>}

                <div style={{width: '100%', borderTop: '1px solid #c9c9c9'}} />

                <div className='mt-4 d-flex flex-row flex-wrap align-items-center w-100'>
                  <div className="inputs" style={{ marginTop: 20 }}>
                    <div className="input">
                      <div className='d-flex flex-col  w-100 mr-3' style={{ alignItems: "center", flexDirection: "row" }}>

                        <BoxInfo
                          id="ramvoice-tp"
                          titleClass='mr-0-4'
                          title={t('menu.genai.simulationStatus')}
                          place="top"
                          containerClass='mr-0-5 '
                          content={t('menu.genai.simulationStatusTooltip')}
                        />
                        <ButtonYesNo
                          onClick={() => onChangeStatusSimulation()}
                          width={150}
                          state={simulationStatus === 0 || simulationStatus === null ? false : simulationStatus}
                          height={30}
                          Yes={t('common.yes')}
                          No={t('common.no')}
                        />
                      </div>
                    </div>
                  </div>

                  <InputNesting
                    containerClass="mr-2 ml-3" style={{minWidth: 350}}
                    ref={url_simulationRef}
                    id="url_tp_simulation"
                    type="text"
                    title={`${t('menu.genai.urlSimulation')}:`}
                    disabled={!simulationStatus}
                  />

                  <InputNesting
                    containerClass="mr-3"
                    ref={Simulation_Step_number_ref}
                    id="Simulation_Step_number_ref"
                    type="text"
                    title={`${t('menu.genai.simulationStepNumber')}:`}
                    disabled={!simulationStatus}
                  />

                  <div className="inputs" style={{ marginTop: 20 }}>
                    <div className="input">
                      <div className='d-flex flex-col  w-100 mr-3' style={{ alignItems: "center", flexDirection: "row" }}>

                        <BoxInfo
                          id="Assisted-Simulation-tp"
                          titleClass='mr-0-4'
                          title={`${t('menu.genai.assistedSimulation')}:`}
                          place="top"
                          containerClass='mr-0-5 '
                          content={t('menu.genai.assistedSimulationTooltip')}
                        />
                        <ButtonYesNo
                          onClick={() => setAssistedSimulation((prev) => prev === 0 ? 1 : 0)}
                          width={150}
                          state={assistedSimulation === 0 || simulationStatus === null ? false : true}
                          height={30}
                          Yes={t('common.yes')}
                          No={t('common.no')}
                          disabled={!simulationStatus}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="inputs" style={{ marginTop: 20 }}>
                  <div className="input">
                    <div className='d-flex flex-col  w-100 mr-3' style={{ alignItems: "center", flexDirection: "row" }}>
                      <SelectNesting
                        id="minimum_passing_score" ref={minimum_passing_score_ref}
                        boxInfo={true} tooltipText="" style={{minWidth: 100, whiteSpace: 'nowrap'}}
                        title={`${t('menu.genai.minimumPassingScore')}:`} containerClass="mr-2"
                      >
                        {Array.from({ length: 100 }, (_, i) => i + 1).map((num) => (
                          <option key={`minimumpassing ${num + 1}:`} value={num} selected={num === minimum_passing_score_ref.current?.value}>
                            {num}
                          </option>
                        ))}
                      </SelectNesting>
                    </div>
                  </div>
                </div>

              </div>

            </div>

          </div>

          <div style={{width: '100%', borderTop: '1px solid #c9c9c9'}} />

          <div className='cont-buttons mt-2 w-100 pb-5'>
            <div className="buttons d-flex flex-row justify-end pr-3">
              <button className="create btn-primary btn-bottom btn-bottom-create" type="submit" style={{ backgroundColor: "#0087FF" }}>
                {t('common.save')}
              </button>
            </div>
          </div>
        </div>

      </form>
      {alert.visible && <Alerts id="alert-ac" title={alert.title} error={alert.error} />}
    </>
  )
}
